import { create } from "zustand";

type GeneralState = {
    isLoading: boolean,
    setIsLoading: (isLoading: boolean) => void,
    isOpenModalSelectCustomField: boolean,
    setIsOpenModalSelectCustomField: (isOpenModalSelectCustomField: boolean) => void,
    isCustomFieldPipeline: boolean,
    setIsCustomFieldPipeline: (isCustomFieldPipeline: boolean) => void,
    isCustomFieldMerchant: boolean,
    setIsCustomFieldMerchant: (isCustomFieldMerchant: boolean) => void,
    isCustomFieldUser: boolean,
    setIsCustomFieldUser: (isCustomFieldUser: boolean) => void,
    isCustomFieldMeeting: boolean,
    setIsCustomFieldMeeting: (isCustomFieldMeeting: boolean) => void,
    isCustomFieldProduct: boolean,
    setIsCustomFieldProduct: (isCustomFieldProduct: boolean) => void,
    errorString: string,
    setErrorString: (errorString: string) => void,
    isShowFormLogLead: boolean,
    setIsShowFormLogLead: (isShowFormLogLead: boolean) => void
}

export const useGeneralStore = create<GeneralState>((set) => ({
    isLoading: false,
    setIsLoading: (isLoading: boolean) => set({ isLoading }),
    isOpenModalSelectCustomField: false,
    setIsOpenModalSelectCustomField: (isOpenModalSelectCustomField: boolean) => set({ isOpenModalSelectCustomField }),
    isCustomFieldPipeline: false,
    setIsCustomFieldPipeline: (isCustomFieldPipeline: boolean) => set({ isCustomFieldPipeline }),
    isCustomFieldMerchant: false,
    setIsCustomFieldMerchant: (isCustomFieldMerchant: boolean) => set({ isCustomFieldMerchant }),
    isCustomFieldUser: false,
    setIsCustomFieldUser: (isCustomFieldUser: boolean) => set({ isCustomFieldUser }),
    isCustomFieldMeeting: false,
    setIsCustomFieldMeeting: (isCustomFieldMeeting: boolean) => set({ isCustomFieldMeeting }),
    isCustomFieldProduct: false,
    setIsCustomFieldProduct: (isCustomFieldProduct: boolean) => set({ isCustomFieldProduct }),
    errorString: '',
    setErrorString: (errorString: string) => set({ errorString }),
    isShowFormLogLead: false,
    setIsShowFormLogLead: (isShowFormLogLead: boolean) => set({ isShowFormLogLead })
}))
